import React, { useCallback, useEffect, useState } from "react";
import { Content } from "../../components/Containers";
import List from "../../components/List";
import { useModal } from "../../context/ModalContext";
import { listAttributesByCategoryIdAndType } from "../../api/Attribute";
import { getAllDrinks } from "../../api/Drink";
import SelectField from "../../components/SelectField";
import { listCategoriesByDrinkId } from "../../api/Category";
import { createTrait, deleteTrait, getTrait, importTraitExcelData, listAllTraits, searchTraits, updateTrait } from "../../api/Trait";
import TraitCard from "./TraitCard";
import { ATTRIBUTE_TYPES, TRAIT_TYPE_OPTIONS } from "../../constants/Consts";
import EditTrait from "./Edit";


export default function Traits({ location }) {
  const { showModal } = useModal();
  const [query, setQuery] = useState("");
  const [all, setAll] = useState(false);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [] });
  const [selected, setSelected] = useState();
  const [drinkOptions, setDrinkOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [attributeOptions, setAttributeOptions] = useState([]);
  const [traitOptions, setTraitOptions] = useState([]);
  const [trait2Options, setTrait2Options] = useState([]);
  const [filterParams, setFilterParams] = useState({
    type: "",
    drinkId: !!location?.state?.drinkId ? location.state.drinkId : "",
    categoryId: !!location?.state?.categoryId ? location.state.categoryId : "",
    attributeId: !!location?.state?.attributeId ? location.state.attributeId : "",
    traitId: "",
    trait2Id: "",
  });

  useEffect(() => {
    const load = async () => {
      const res = await getAllDrinks("nameBr", "ASC");
      setDrinkOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    load();
  }, []);

  useEffect(() => {
    const load = async (drinkId) => {
      console.log(drinkId)
      const res = await listCategoriesByDrinkId(drinkId);
      setCategoryOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    if(!!filterParams.drinkId){
      load(filterParams.drinkId);
    } else{
      setCategoryOptions([]);
      setAttributeOptions([]);
      setTraitOptions([]);
      setTrait2Options([]);
    }
  }, [filterParams.drinkId]);

  useEffect(() => {
    const load = async (categoryId) => {
      const res = await listAttributesByCategoryIdAndType(categoryId, ATTRIBUTE_TYPES.TRAIT);
      setAttributeOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    if(!!filterParams.categoryId){
      load(filterParams.categoryId);
    } else{
      setAttributeOptions([]);
      setTraitOptions([]);
      setTrait2Options([]);
    }
  }, [filterParams.categoryId]);

  useEffect(() => {
    const load = async (attributeId) => {
      const res = await listAllTraits(
        "order", 
        "ASC", 
        attributeId,
        null,
        null,
      );
      setTraitOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    if(!!filterParams.attributeId){
      load(filterParams.attributeId);
    } else{
      setTraitOptions([]);
      setTrait2Options([]);
    }
  }, [filterParams.attributeId]);

  useEffect(() => {
    const load = async (traitId) => {
      const res = await listAllTraits(
        "order", 
        "ASC", 
        null,
        null,
        traitId,
      );
      setTrait2Options(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    if(!!filterParams.traitId){
      load(filterParams.traitId);
    } else{
      setTrait2Options([]);
    }
  }, [filterParams.traitId]);

  const load = useCallback(() => {
    const search = async () => {
      const { type ,drinkId, categoryId, attributeId, traitId, trait2Id } = filterParams;
      const res = await searchTraits(
        query, 
        all, 
        page, 
        "order", 
        "ASC", 
        drinkId, 
        categoryId, 
        attributeId, 
        type,
        !!trait2Id ? trait2Id : !!traitId ? traitId : null,
      );
      setData(res);
    }

    search();
  }, [query, all, page, filterParams]);

  useEffect(() => {
    load();
  }, [query, all, page, load, filterParams]);

  const importExcel = async (data) => {
    try {
      await  importTraitExcelData(data);
      load();
      showModal("Características importadas com sucesso!", "success", 10);
    } catch (e) {
      console.log(e.message ?? e);
      showModal("Falha ao importar características", "error", 10);
    }
  }

  return (
    <>
      <Content>
        <List
          data={data}
          query={query}
          updateQuery={setQuery}
          status={all}
          updateStatus={setAll}
          statusList={[
            { label: "Todos", value: true },
            { label: "Ativos", value: false },
          ]}
          updatePage={setPage}
          onNew={() =>
            setSelected({
              nameBr: "",
              type: "",
              hexColor: "",
              parent: null,
              traits: [],
              attribute: null,
              order: 0,
            })
          }
          Item={(item) => (
            <TraitCard
              key={"ku" + item.id}
              trait={item}
              onEdit={async () => {
                const loaded = await getTrait(item);
                setSelected(loaded);
              }}
              onDelete={async () => {
                try {
                  await deleteTrait(item);
                  load();
                } catch (e) {
                  showModal("A característica não pode ser apagada", "warn", 10);
                }
              }}
            />
          )}
          renderBeforeContent={
            <div className="mt-[-20px] mb-6 flex flex-row gap-6 flex-wrap">
              <SelectField
                label="Tipo"
                className="w-[200px]"
                value={filterParams.type} 
                options={TRAIT_TYPE_OPTIONS} 
                update={(type) => setFilterParams(p => ({ ...p, ...{ type } }))} 
              />
              <SelectField
                label="Bebida"
                className="w-[200px]"
                value={filterParams.drinkId} 
                options={drinkOptions} 
                update={(drinkId) => setFilterParams(p => ({ ...p, ...{ drinkId, categoryId: "", attributeId: "", traitId: "", trait2Id: "" } }))} 
              />
              { !!filterParams.drinkId &&
                <SelectField
                  label="Categoria"
                  className="w-[200px]"
                  value={filterParams.categoryId} 
                  options={categoryOptions} 
                  update={(categoryId) => setFilterParams(p => ({ ...p, ...{ categoryId, attributeId: "", traitId: "", trait2Id: "" } }))} 
                />
              }
              { !!filterParams.categoryId &&
                <SelectField
                  label="Atributo"
                  className="w-[200px]"
                  value={filterParams.attributeId} 
                  options={attributeOptions} 
                  update={(attributeId) => setFilterParams(p => ({ ...p, ...{ attributeId, traitId: "", trait2Id: "" } }))} 
                />
              }
              { !!filterParams.attributeId &&
                <SelectField
                  label="Característica"
                  className="w-[200px]"
                  value={filterParams.traitId} 
                  options={traitOptions} 
                  update={(traitId) => setFilterParams(p => ({ ...p, ...{ traitId, trait2Id: "" } }))} 
                />
              }
              { !!filterParams.traitId &&
                <SelectField
                  label="Característica 2"
                  className="w-[200px]"
                  value={filterParams.trait2Id} 
                  options={trait2Options} 
                  update={(trait2Id) => setFilterParams(p => ({ ...p, ...{ trait2Id } }))} 
                />
              }
            </div>
          }
          onReadExcelInput={importExcel}
          excelExampleHeaders={["nameBr", "order", "attributeId", "traitId", "type", "hexColor"]}
        />
      </Content>
      <EditTrait
        selected={selected}
        onClose={() => setSelected(null)}
        onSave={async (trait) => {
          try {
            if (!!trait.id) {
              await updateTrait(trait);
            } else {
              await createTrait(trait);
            }
            setSelected(null);
            load();
          } catch (e) {
            showModal("Falha ao gravar característica", "error", 10);
          }
        }}
      />
    </>
  );
}
